export class MyFocusLoyaltyEmailTemplateItem {
	pk: string; //LOYEMAILTEMPLATE_venueKey
	sk: string; //:UUID
	name: string;
	templateHtml: string;
	templateJson: string;
	created: string;
	modified: string;

	public constructor(init?: Partial<MyFocusLoyaltyEmailTemplateItem>) {
		Object.assign(this, init);
	}
}
